import { useTheme, useMediaQuery } from '@material-ui/core'

export const useIsMobile = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return isMobile
}
